import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  gateways: [],
};

const gatewaysSlice = createSlice({
  name: "gateways",
  initialState,
  reducers: {
    setGateways(state, action) {
      state.gateways = action.payload;
    },
  },
});

export const { setGateways } = gatewaysSlice.actions;

export default gatewaysSlice.reducer;
